export enum EFlightCFITypes {
  NONE = 'NONE',
  CFI = 'CFI',
  CFII = 'CFII',
  MEI = 'MEI'
}
